<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Bowie</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head1" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">We are grateful to the University Archives and Special Collections Department, Thurgood Marshall Library, Bowie State University; Fannie L. Basim; Holy Family Catholic Church; Huntington Heritage Society; Jack Blevins; Dr. James Jacobs; James Smart; Katherine Hayes; Maryland State Archives–Maryland Commission on Artistic Property; Mike Rauck; Prince George’s County Historical Society; Sacred Heart Church; Safeway, Inc.; Steve Miller and the Miller family; Rabbi Steve Weisman and Temple Solel; and Susan G. Pearl for photographs and captions.</p>
<p class="para">Unless otherwise noted, all images are courtesy of City of Bowie Museums.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?54671ba3